import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createProject } from './api_project';

const initialState = {};

export const createProjectData = createAsyncThunk(
  'ui/fetchCreateProject',
  async (obj, thunkAPI) => {
    const { getState } = thunkAPI;
    const response = await createProject(obj);
    return response.data;
  }
);

const createProjectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    resetProjectStateReducer: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProjectData.pending, (state) => {
        return {
          ...state,
          status: 'loading',
          createProjectLoaded: false,
          createProjectFetchFailed: false,
          createProject: initialState,
        };
      })
      .addCase(createProjectData.fulfilled, (state, action) => {
        return {
          ...state,
          status: 'success',
          createProject: action.payload,
          createProjectFetchFailed: false,
          createProjectLoaded: true,
        };
      })
      .addCase(createProjectData.rejected, (state) => {
        return {
          ...state,
          createProjectFetchFailed: true,
          status: 'failed',
          createProjectLoaded: true,
        };
      });
  },
});

export const { setInverterData } = createProjectSlice.actions;
export const { resetProjectStateReducer } = createProjectSlice.actions;

export const getProjectData = (state) => state.project?.createProject;
export const getProjectDataStatus = (state) => state.project?.status;

export default createProjectSlice.reducer;
